/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./cityPageJoin.vue?vue&type=template&id=6a4f8f7e&scoped=true"
import script from "./cityPageJoin.vue?vue&type=script&lang=js"
export * from "./cityPageJoin.vue?vue&type=script&lang=js"
import style0 from "./cityPageJoin.vue?vue&type=style&index=0&id=6a4f8f7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4f8f7e",
  null
  
)

export default component.exports